import { render, staticRenderFns } from "./HospitalIncome.vue?vue&type=template&id=5b3d8d36&scoped=true"
import script from "./HospitalIncome.vue?vue&type=script&lang=js"
export * from "./HospitalIncome.vue?vue&type=script&lang=js"
import style0 from "./HospitalIncome.vue?vue&type=style&index=0&id=5b3d8d36&prod&scoped=true&lang=css"
import style1 from "./HospitalIncome.vue?vue&type=style&index=1&id=5b3d8d36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d8d36",
  null
  
)

export default component.exports